import { getDeviceId } from '../../util/device-id';
import { changePlayerTeam } from '../../firebase/firebase-db';
import { Check, User } from 'react-feather';
import type { PlayerDto, PlayerTeam } from '@/game/core/player';
import { useKeyboardShortcuts } from '@/util/use-keyboard-shortcuts';
import { useMemo, useRef } from 'react';

interface TeamSwitcherProps {
    gameId: string;
    player: PlayerDto;
}

export function TeamSwitcher({ gameId, player }: TeamSwitcherProps) {
    const deviceId = getDeviceId();
    const teams = ['red', 'blue', 'green', 'yellow', 'black', 'orange', 'white', 'purple', 'pink', 'gray'];

    function cyclePlayerTeam() {
        const currentTeamIndex = teams.indexOf(player.team as string);
        const nextIndex = (currentTeamIndex + 1) % teams.length;
        const newTeam = teams[nextIndex] as PlayerTeam;
        changePlayerTeam(gameId, player.uid, newTeam);
    }

    const textColor = player.team === 'white' ? 'text-black' : 'text-white';
    const bgColors = ['black', 'white'].includes(player.team as string)
        ? `bg-${player.team} hover:bg-${player.team}/30`
        : `bg-${player.team}-400 hover:bg-${player.team}-500`;

    const btnIsInactive = player.uid !== deviceId || (player.uid === deviceId && player.ready);
    const buttonRef = useRef<HTMLButtonElement>(null);
    const shortcuts = useMemo(() => btnIsInactive ? [] : [
        { key: ' ', action: () => buttonRef.current?.click() },
    ], [btnIsInactive]);

    useKeyboardShortcuts(shortcuts);

    return (
        <button ref={buttonRef} className={`p-2 ${bgColors} ${textColor} ${btnIsInactive ? 'pointer-events-none' : 'cursor-pointer ring-4 ring-primary/50'} rounded-full`} onClick={cyclePlayerTeam}>
            {!player.ready && <User className="w-4 h-4" />}
            {player.ready && <Check className="w-4 h-4" />}
        </button>
    );
}
